
export enum ContactMethod {
    Call = 'Call',
    Message = 'Message'
}
